import Vue from 'vue';
import router from '../router';
import http from '../api';

export const login = ({ commit, dispatch }, body) => {
  commit('setError', '');
  http.post('/auth/login', body).then(response => {
    if (response.status == 201) {
      router.push({
        name: 'login-activate',
        params: {
          Login: body.Login,
          Password: body.Password,
          Secret: response.data.data.Secret,
          Sign: response.data.data.Sign,
          Message: response.data.message
        }
      });
    } else if (response.status === 200) {
      Activate({ commit, dispatch }, body, response);
      console.log(router);
      router.push('/');
    } else if (response.status === 202) {
      router.push({
        name: 'login-confirm',
        params: {
          Login: body.Login,
          Password: body.Password
        }
      });
    } else {
      commit('setError', response.data.message);
    }
  });
};

export const activate = ({ commit, dispatch }, body) => {
  commit('setError', '');
  console.log(body);
  return http.post('/auth/login/activate', body).then(response => {
    if (response.status == 201) {
      router.push({
        name: 'login-confirm',
        params: {
          Login: body.Login,
          Password: body.Password
        }
      });
      return Promise.resolve('Successful');
    } else if (response.status == 200) {
      return Promise.resolve(response.data.message);
    } else {
      commit('setError', response.data.message);
      return Promise.reject(response.data.message);
    }
  });
};
function Activate({ commit, dispatch }, body, response) {
  commit('setToken', response.data.data.Token);
  commit('setPermissions', response.data.data.Permissions);
  commit('setLogin', body.Login);
  commit('setRole', response.data.data.Roles);
  commit('setAuthenticated', true);
  commit('setExpiredAt', new Date(response.data.data.ExpiredAt));
  commit('setAbilities', response.data.data.Token);
}
export const confirm = ({ commit, dispatch }, body) => {
  commit('setError', '');
  http
    .post('/auth/login/confirm', body)
    .then(response => {
      if (response.status === 200) {
        Activate({ commit, dispatch }, body, response);
        console.log(router);
        router.push('/');
      } else {
        commit('setAuthenticated', false);
        router.push('/login');
      }
    })
    .catch(err => {
      console.log(err);
      commit('setAuthenticated', false);
      router.push('/login');
    });
};

export const logout = ({ state, commit, dispatch }) => {
  commit('setToken', null);
  commit('setPermissions', []);
  commit('setLogin', null);
  commit('setRole', null);
  commit('setAuthenticated', false);
  commit('setExpiredAt', null);
  commit('setAbilities', null);
  router.push('/login');
};

export const checkAuth = ({ state, commit, dispatch }) => {
  if (state.tokenExpire && new Date(state.tokenExpire) < new Date()) {
    return dispatch('logout');
  } else {
    return;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js